import { call, put, takeLatest } from 'redux-saga/effects';
import { addNegativeToast } from 'modules/toastContainer';
import { addToRootSaga } from 'store';
import * as actions from './actions';
import * as actionTypes from './actionTypes';
import { WhatsAppReceived } from './types';
import { getWhatsAppMessages } from 'api/WhatsAppMessagesAPI';

/**
 * fetchWhatsAppMessages
 * Saga for fetching recent WhatsApp messages
 */
export function* fetchWhatsAppMessages() {
  try {
    const response: { data: WhatsAppReceived[] } = yield call(getWhatsAppMessages);
    yield put(actions.fetchWhatsAppMessagesResponse(response.data));
  } catch (error) {
    const message = 'Error fetching WhatsApp messages. Please try again later.';
    yield put(addNegativeToast(message));
  }
}

addToRootSaga([takeLatest(actionTypes.FETCH_WHATSAPP_MESSAGES_REQUEST, fetchWhatsAppMessages)]);
